<div class="container container-custom">
    <div class="row align-items-center">
        <div class="col-xl-12">
            <ng-container *ngIf="!isLoading else loading">
                <ng-container *ngIf="paymentSession?.sessionToken && !transactionStatus">
                    <div class="card p-3">
                        <div>
                            <div class="d-flex flex-wrap gap-3 justify-content-between align-items-center">
                                <div class="d-flex gap-2 align-items-center">
                                    <div class="initial_avator bg-primary">
                                        {{ getInitials(invoiceResponse.patientName) }}
                                    </div>
                                    <div class="patient_title">
                                        <h6 class="mb-0">{{this.invoiceResponse.patientName}}</h6>
                                    </div>
                                </div>
                                <div><i class="fa fa-solid fa-phone me-1"></i> {{this.invoiceResponse.patientPrimaryPhone}}
                                </div>
                            </div>
                            <div class="d-flex flex-wrap gap-3 justify-content-between mt-1">
                                <div><i class="fa fa-solid fa-envelope me-1"></i>
                                    {{this.invoiceResponse.patientPrimaryEmailAddress}}</div>
                        
                                <div><i class="fa fa-solid fa-hospital-o me-1"></i> {{this.invoiceResponse.practiceName}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <form [formGroup]="paymentForm">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="row">
                                        <div class="col-md-4 d-none d-md-block"></div>
                                        <div class="col-md-8">
                                            <div class="form-group"
                                                [ngClass]="paymentForm.get('transactionAmount')?.invalid && paymentForm.get('transactionAmount')?.touched ? 'has-error' : ''">
                                                <label>Payment Amount</label>
                                                <input type="text" class="form-control" formControlName="transactionAmount"
                                                    placeholder="Enter Amount" />
                                                <div class="validation_msg"
                                                    *ngIf="paymentForm.get('transactionAmount')?.invalid && paymentForm.get('transactionAmount')?.touched">
                                                    <div *ngIf="paymentForm.get('transactionAmount')?.hasError('required')">
                                                        Amount is required</div>
                                                    <div *ngIf="paymentForm.get('transactionAmount')?.hasError('pattern')">
                                                        Amount is Invalid</div>
                                                </div>
                                                <div class="validation_msg" *ngIf="this.paymentForm.value.transactionAmount > 999">
                                                    Please try the amount less than $1000</div>
                                            </div>
                                        </div>
                                    </div>
                                    <app-credit-card-payment></app-credit-card-payment>
                                    <div class="d-flex justify-content-end">
                                        <button class="btn btn-primary" (click)="processPayment()">Pay Now</button>
                                    </div>
                                    <span>{{tokenErrorMessage}}</span>
                                </div>
                            </div>
                        
                        </form>
                    </div>
                </ng-container>
    
                <ng-container *ngIf="transactionStatus && transactionStatus === 'APPROVED'">
                    <div class="card">
                        <div class="d-flex gap-2 justify-content-center align-items-center min_height">
                            <div>
                                <h5 class="h5">Payment Details</h5>
                                <div class="d-flex gap-2"><label class="fw-bold">Transaction Amount</label>
                                    <span>{{ paymentResponseModel.transactionAmount |
                                        currency:'':'symbol':'1.2-2'}}</span>
                                </div>
                                <div class="d-flex gap-2"><label class="fw-bold">Transaction Status</label>
                                    <span class="text-success_info fw-bold">{{transactionStatus}}</span>
                                </div>
                            </div>
                            <img src="images/success.png" class="img-fluid d-none d-md-block" width="300">
                        </div>
                    </div>
                </ng-container>
    
                <ng-container *ngIf="transactionStatus && transactionStatus !== 'APPROVED'">
                    <div class="card">
                        <div class="d-flex gap-2 justify-content-center align-items-center min_height">
                            <div>
                                <h5 class="h5">Payment Details</h5>
                                <div class="d-flex gap-2"><label class="fw-bold">Transaction Amount</label>
                                    <span>{{ paymentResponseModel.transactionAmount |
                                        currency:'':'symbol':'1.2-2'}}</span>
                                </div>
                                <div class="d-flex gap-2"><label class="fw-bold">Transaction Status</label>
                                    <span class="text-warning_info fw-bold">{{transactionStatus}}</span>
                                </div>
                                <ng-container *ngIf="paymentResponseModel.errorReason !== ''">
                                    <div class="d-flex gap-2"><label class="fw-bold">Reason</label>
                                        <span class="text-warning_info fw-bold">{{paymentResponseModel.errorReason}}</span>
                                    </div>
                                </ng-container>
                            </div>
                            <img src="images/cancel.png" class="img-fluid d-none d-md-block" width="300">
                        </div>
                    </div>
                </ng-container>
    
                <ng-container *ngIf="isExpired">
                    <div class="card min_height">
                        <div class="col-lg-12 p-4 session-page">
    
                            <div class="d-flex justify-content-center">
                                <img src="images/session_timeout.png">
                            </div>
    
                            <div class="text-center session-page-content">
                                <p class="f-20 m-0 f-w-400 mb-4">Your payment link has expired. Please try to contact the
                                    practice administrator.</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>

<!-- <ng-container *ngIf="transactionStatus">
        <span>{{transactionStatus}}</span>
        <ng-container *ngIf="paymentResponseModel.errorReason !== ''">
            <span class="text-center text-danger mt-2">{{paymentResponseModel.errorReason}}</span>
        </ng-container>
    </ng-container> -->

<!-- <ng-container *ngIf="isExpired">
        <span>Expired</span>
    </ng-container> -->


<ng-template #loading>
    <div class="card">
        <app-card-skeletal [rows]="1" [cardsPerRow]="1" [cardHeight]="140"></app-card-skeletal>
    </div>
    <div class="card">
        <div class="row">
            <div class="col-md-4 d-none d-md-block">
                <app-card-skeletal [rows]="1" [cardsPerRow]="1" [cardHeight]="310"></app-card-skeletal>
            </div>
            <div class="col-md-8">
                <app-card-skeletal [rows]="5" [cardsPerRow]="1" [cardHeight]="50"></app-card-skeletal>
            </div>
        </div>
    </div>
</ng-template>